import { IElement } from '../types/IElement'
import TopicVersionTitleAndSummary from '../TopicVersionTitleAndSummary'
import { AnimatePresence, motion } from 'framer-motion'
import { TopicCompletionPage } from '../TopicCompletionPage'
import { ViewElement } from '../ViewElement'
import React, { FC, useContext } from 'react'
import { TopicDetailContext } from '../TopicDetailContext'

interface IProps {
  elements: IElement[]
  previousElementIndex: number
  currentElementIndex: number
}

export const MultiPageElement: FC<IProps> = (props) => {
  const { topic, topicVersion } = useContext(TopicDetailContext)
  const { elements, previousElementIndex, currentElementIndex } = props

  const goingRight = previousElementIndex < currentElementIndex

  const transition = {
    initial: { x: goingRight ? 500 : -500, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { opacity: 0 },
    transition: {
      x: { type: 'tween', easy: 'easeOut', duration: 0.5 },
      opacity: { duration: 0.3 }
    }
  }

  const index = currentElementIndex
  let page = null as any

  if (index === -1) {
    page = (
      <TopicVersionTitleAndSummary
        key={index}
        title={topicVersion?.title}
        summary={topicVersion?.summary}
      />
    )
  } else if (index === elements.length) {
    return (
      <motion.div
        key={index}
        className="page page-system-generated-completion"
        {...transition}
      >
        <TopicCompletionPage />
      </motion.div>
    )
  }
  const element = elements[index]

  if (element) {
    const { type } = element

    page = (
      <motion.div key={index} className={`page page-${type}`} {...transition}>
        <div
          className={`ql-editor page-content page-content-${type} element element-${type} element-mode-view`}
        >
          <ViewElement
            {...element}
            topicId={topic.id}
            isVisible={true}
            shouldTrackMedia={true}
            quizResponses={topic?.enrolmentOrSelfEnrol?.quizResponses || []}
            allowRetry={!!topic?.currentTopicVersion?.allow_retry}
          />
        </div>
      </motion.div>
    )
  }

  return <AnimatePresence>{page}</AnimatePresence>
}
